export class ExecuteBlipFunctionActionSettings {
    static $inject = ['init'];
    constructor(init) {
        if (!init) {
            this.function = 'run';
            this.source = '';
            this.inputVariables = [];
        }
        else {
            Object.assign(this, init);
        }
    }
}
